
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import logoSrc from '../assets/brand/logo.svg';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Design/Brand" mdxType="Meta" />
    <h1>{`Brand`}</h1>
    <p>{`These elements are used to signify Cloud Four projects.`}</p>
    <h2>{`Logo`}</h2>
    <Canvas mdxType="Canvas">
  <Story name="Logo" mdxType="Story">{`<img src="${logoSrc}" alt="Cloud Four">`}</Story>
    </Canvas>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export const logo = () => (
          `<img src="${logoSrc}" alt="Cloud Four">`
        );
logo.storyName = 'Logo';
logo.parameters = { storySource: { source: '`<img src=\"${logoSrc}\" alt=\"Cloud Four\">`' } };

const componentMeta = { title: 'Design/Brand', includeStories: ["logo"],  };

const mdxStoryNameToKey = {"Logo":"logo"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;